module.exports = __webpack_public_path__ + "static/media/user.4e2bb61e.svg";